var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profile)?_c('span',[_vm._v(_vm._s(_vm.profile.DisplayName))]):_c('span',[_c('skeleton-text',{attrs:{"lines":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }